var EventEmitter = require('events'); // function Interface() {
// 	this.constructor();
// }
// Interface.prototype = new EventEmitter();
// Interface.prototype.constructor = EventEmitter;
// var camelCase = function (s) {
// 	s = s.split('_').map(function (s) {
// 		s = s.toLowerCase();
// 		return s.charAt(0).toUpperCase() + s.slice(1);
// 	}).join('');
// 	return s[0].toLowerCase() + s.slice(1);
// };


function Client() {
  EventEmitter.call(this);
}

Client.prototype = new EventEmitter();
Client.prototype.constructor = EventEmitter;

Client.prototype.setStore = function (store, singleton) {
  if (singleton) {
    this.store = null;
    this.state = store;
  } else {
    this.store = store;
  }
};

Client.prototype.setState = function (data) {
  if (typeof arguments[0] === 'string') {
    var type = arguments[0];
    data = arguments[1];
    var d = Object.assign({}, this.state[type]);
    this.state[type] = d;
    var changes = {};
    changes[type] = {};

    for (var name in data) {
      if (d[name] !== data[name]) {
        d[name] = data[name];
        changes[type][name] = data[name];
      }
    }

    return changes;
  } else {
    if (this.store) {
      var id = this.state ? this.state.id : data.id;
      var changes = this.store.set(id, data);
      this.state = this.store[id];
      return changes;
    } else {
      return this._setState(data);
    }
  }
};

Client.prototype._setState = function (data) {
  var changes = {};
  var hasChanges = false;
  var s = this.state;

  for (var i in data) {
    if (typeof data[i] === 'object' || s[i] !== data[i]) {
      hasChanges = true;
      changes[i] = data[i];
      this.state[i] = data[i];
    }
  }

  if (hasChanges) {
    //this.state = Object.assign({}, this.state, changes);
    //console.log('emit update', changes);
    this.emit('update', this.state, changes);
    return changes;
  } else {
    //if (callback) callback();
    return null;
  }
};

Client.prototype.getState = function () {
  return this.state.id in this.store ? this.store[this.state.id] : {};
}; // Client.prototype.createSettings = function (settings) {
// 	this.settingDefaults = {};
// 	this.settingNames = [];
// 	for (var i in settings) {
// 		this.settingNames.push(i);
// 		this.settingDefaults[i] = settings[i];
// 		this.state[i] = settings[i];
// 	}
// 	//this.log('created settings', this.state);
// };


Client.prototype.bindInterface = function (deviceInterface, config) {
  this.deviceInterface = deviceInterface;
  var states = {};

  for (var state in deviceInterface.states) {
    if (typeof states[state] === 'undefined' && 'defaultValue' in deviceInterface.states[state]) {
      states[state] = deviceInterface.states[state].defaultValue;
    } else states[state] = null;
  }

  if (config) {
    for (var i in config) {
      states[i] = config[i];
    }
  }

  this.setState(states);
  var type, action;

  for (type in deviceInterface.devices) {
    if (this[type]) {
      console.log('Invalid device: ' + type + ' already defined');
    }

    this[type] = new EventEmitter();

    if ('actions' in deviceInterface.devices[type]) {
      for (action in deviceInterface.devices[type].actions) {
        if (typeof deviceInterface.devices[type].actions[action] != 'function') {
          console.log('setting invalid:', setting, typeof deviceInterface.devices[type].actions[action]);
          if (process.env.NODE_ENV === 'dev') process.exit();
        }

        this[type][action] = deviceInterface.devices[type].actions[action].bind(this);
        console.log('action: .', type, action, typeof deviceInterface.devices[type].actions[action]);
      }
    }

    if ('settings' in deviceInterface.devices[type]) {
      for (setting in deviceInterface.devices[type].settings) {
        if (typeof deviceInterface.devices[type].settings[setting] != 'function') {
          console.log('setting invalid:', setting, typeof deviceInterface.devices[type].settings[setting]);
          if (process.env.NODE_ENV === 'dev') process.exit();
        }

        this[type][setting] = deviceInterface.devices[type].settings[setting].bind(this);
        console.log('setting: .', type, setting, typeof deviceInterface.devices[type].settings[setting]);
      }
    }
  }

  this.parsers = {};

  for (var parser in deviceInterface.parsers) {
    this.parsers[parser] = deviceInterface.parsers[parser].bind(this);
  }
}; // Client.prototype._createSettings = function (settings) {
// 	// log('changing settings', settings);
// 	var changes = {};
// 	var hasChanges = false, value, d;
// 	for (var name in settings) {
// 		if ('defaultValue' in settings[name]) {
// 			value = settings[name]; //.defaultValue;
//
// 			d = {};
// 			d[name] = settings[name];
//
// 			var c = this.setState(d);
// 			if (c) {
// 				//this.log('changed setting:', name + ' = ' + value, '(default ' + this.settingDefaults[name] + ')');
// 				hasChanges = true;
// 				changes[name] = value;
// 			}
// 		}
// 	}
// 	if (hasChanges) {
// 		//this.log('settings-changed', changes);
// 		this.emit('settings-changed', changes);
// 	}
// };


module.exports = Client;